"use strict";

export default class Search {
    constructor(form, resultContainer) {
        let _this = this;
        this.form = $(form);
        this.searchBox = this.form.find("input[name=search]");
        this.url = this.form.attr("action");
        this.searchTimeout = 0;
        this.resultContainer = $(resultContainer);

        // other form data
        this.data = {};

        $(form).find("input").each(function() {
            var elem = $(this);
            if (elem.attr("type") != "checkbox" || elem.prop("checked")) {
                _this.data[elem.attr("name")] = elem.val();
            }
        });

        $(form).find("select").each(function() {
            var elem = $(this);
            _this.data[elem.attr("name")] = elem.val();
        });

        this.init();
    }

    init() {
        let _this = this;

        this.searchBox.on("input propertychange paste", function() {
            let text = $(this).val();

            if (_this.searchTimeout) {
                window.clearTimeout(_this.searchTimeout);
                _this.searchTimeout = 0;
            }

            _this.data.search = text;

            _this.searchTimeout = window.setTimeout(function() {
                $.ajax({
                    url: _this.url,
                    data: _this.data,
                    dataType: "html",
                    success: function(result) {
                        _this.resultContainer.empty().html(result);

                        // bind any events required
                        new FormConfirmDelete();
                    },
                    error: function() {

                    }
                });
            }, 250);
        });
    }
}
